export { default as AvanttiIcon } from './AvanttiIcon';
export { default as AvanttiLogo } from './AvanttiLogo';
export { default as Ticket } from './Ticket';
export { default as Edit3 } from './Edit3';
export { default as ArrowDownCircle } from './ArrowDownCircle';
export { default as CoinsHand } from './CoinsHand';
export { default as DollarSign } from './DollarSign';
export { default as Link } from './Link';
export { default as QrCode02Icon } from './QrCode02Icon';
export { default as Sale01 } from './Sale01';

export { default as WhatsAppIcon } from './WhatsAppIcon';
export { default as IconAvantti1 } from './IconAvantti1';
export { default as IconCard1 } from './IconCard1';
export { default as IconCard2 } from './IconCard2';
export { default as IconCard3 } from './IconCard3';
export { default as IconEnjoy1 } from './IconEnjoy1';
export { default as IconEnjoy2 } from './IconEnjoy2';
export { default as IconEnjoy3 } from './IconEnjoy3';
export { default as IconMove1 } from './IconMove1';
export { default as IconMove2 } from './IconMove2';
export { default as IconMove3 } from './IconMove3';
export { default as IconPlay1 } from './IconPlay1';
export { default as IconPlay2 } from './IconPlay2';
export { default as IconPlay3 } from './IconPlay3';
export { default as IconSmile1 } from './IconSmile1';
export { default as IconSmile2 } from './IconSmile2';
export { default as IconSmile3 } from './IconSmile3';
export { default as IconTicket1 } from './IconTicket1';
export { default as IconTicket2 } from './IconTicket2';
export { default as IconTicket3 } from './IconTicket3';
export { default as OrderSuccess } from './OrderSuccess';
export { default as OrderError } from './OrderError';
export { default as OrderTimeout } from './OrderTimeout';
